import React from 'react';

const SHOTLISTS_SCREENSHOTS = [
  'https://firebasestorage.googleapis.com/v0/b/davinese-dcf1a.firebasestorage.app/o/shotlists_screenshots%2F4.png?alt=media&token=ff7398fa-bc77-4ecb-ae8b-7faea2f2a90e',
  'https://firebasestorage.googleapis.com/v0/b/davinese-dcf1a.firebasestorage.app/o/shotlists_screenshots%2F3.png?alt=media&token=3b3f8cc3-f966-4e23-b04d-e2fdf9175005',
  'https://firebasestorage.googleapis.com/v0/b/davinese-dcf1a.firebasestorage.app/o/shotlists_screenshots%2F4.png?alt=media&token=ff7398fa-bc77-4ecb-ae8b-7faea2f2a90e',
  'https://firebasestorage.googleapis.com/v0/b/davinese-dcf1a.firebasestorage.app/o/shotlists_screenshots%2F1.png?alt=media&token=afdfc5bd-798c-4154-a323-d49eff973208',
  'https://firebasestorage.googleapis.com/v0/b/davinese-dcf1a.firebasestorage.app/o/shotlists_screenshots%2F5.png?alt=media&token=8629de45-b751-43f6-9f01-acda3ecf1c65',
];

const OriginalThreeDimensionViewpoint = ({ fullScreen = false }) => {
  const containerStyle = fullScreen
    ? { ...styles.container, height: '100%' }
    : styles.container;

  return (
    <div style={containerStyle}>
      {/* 3D Scene Wrapper */}
      <div style={styles.scene}>

        {/* Central Text */}
        {/* <div style={styles.textWrapper}>
          <h1 style={styles.title}>
            Shot Lists<br />
            +<br />
            Viewfinder
          </h1>
        </div> */}

        {/* Floating Screenshots */}
        {SHOTLISTS_SCREENSHOTS.map((src, index) => (
          <div
            key={index}
            style={{
              ...styles.cardBase,
              ...getCardStyle(index),
            }}
          >
            <img
              src={src}
              alt={`Shotlist Preview ${index + 1}`}
              style={styles.image}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

// --- Styles & 3D Configuration ---

const styles = {
  container: {
    position: 'relative',
    width: '100%',
    height: '600px',
    backgroundColor: '#0a0a0a',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Add padding to prevent hard clipping if cards rotate near the edge
    padding: '20px', 
  },
  scene: {
    position: 'relative',
    width: '100%',
    height: '100%',
    perspective: '1200px',
    transformStyle: 'preserve-3d',
  },
  textWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10,
    textAlign: 'center',
    pointerEvents: 'none',
  },
  title: {
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    fontWeight: '800',
    fontSize: 'clamp(3rem, 6vw, 6rem)',
    color: '#ffffff',
    letterSpacing: '-0.06em',
    margin: 0,
    lineHeight: 1,
    textShadow: '0 10px 30px rgba(0,0,0,0.5)',
  },
  cardBase: {
    position: 'absolute',
    borderRadius: '12px',
    boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
    transformStyle: 'preserve-3d',
    willChange: 'transform',
    
    // --- FIXES START HERE ---
    // 1. Hides the jagged back-face of the 3D element
    backfaceVisibility: 'hidden', 
    WebkitBackfaceVisibility: 'hidden',
    
    // 2. Transparent outline forces the browser to use anti-aliasing on edges
    outline: '1px solid transparent',
    
    // 3. Hardware acceleration hack
    transform: 'translate3d(0,0,0)', 
    // --- FIXES END HERE ---
  },
  image: {
    display: 'block',
    width: '100%',
    height: 'auto',
    borderRadius: '12px',
    filter: 'brightness(0.9)',
    
    // Ensure the image itself doesn't flicker during 3D rotation
    backfaceVisibility: 'hidden',
    WebkitBackfaceVisibility: 'hidden',
  }
};
// Helper to generate "Random" but curated positions for the Confetti look
const getCardStyle = (index) => {
  const configs = [
    // 1. Left Side - Background (Blurred & Small)
    {
      top: '-10%',
      left: '5%',
      width: '300px',
      transform: 'translateZ(-200px) rotateY(25deg) rotateX(10deg) rotateZ(-15deg)',
      filter: 'blur(3px)',
      opacity: 0.7,
      zIndex: 1,
    },
    // 2. Right Side - Foreground (Blurred & Large - "Too Close")
    {
      bottom: '-15%',
      right: '5%',
      width: '450px',
      transform: 'translateZ(100px) rotateY(-30deg) rotateX(-20deg) rotateZ(10deg)',
      filter: 'blur(4px)',
      zIndex: 5,
    },
    // 3. Center Right - Midground (Sharp Focus)
    {
      top: '5%',
      right: '25%',
      width: '350px',
      transform: 'translateZ(-50px) rotateY(-15deg) rotateX(5deg) rotateZ(15deg)',
      filter: 'blur(0px)', // Sharp
      zIndex: 2,
    },
    // 4. Center Left - Midground (Slight Blur)
    {
      bottom: '10%',
      left: '25%',
      width: '320px',
      transform: 'translateZ(0px) rotateY(20deg) rotateX(-10deg) rotateZ(-5deg)',
      filter: 'blur(1px)',
      zIndex: 3,
    },
    // 5. Center/Top - Deep Background (Very Blurred)
    {
      top: '-20%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '280px',
      transform: 'translateX(-50%) translateZ(-400px) rotateY(0deg) rotateX(45deg) rotateZ(5deg)',
      filter: 'blur(5px)',
      opacity: 0.5,
      zIndex: 0,
    }
  ];

  return configs[index % configs.length];
};

export default OriginalThreeDimensionViewpoint;
